import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getPortalBranding } from '../features/portal/portal'
import { PORTAL_BRAND_STATUS } from '../components/PortalBrand/portalBrandStatus'

const portalBrandFor = (answer) => {
  if (!answer) return { status: PORTAL_BRAND_STATUS.PENDING }
  if (answer.failed) return { status: PORTAL_BRAND_STATUS.NEUTRAL }
  if (!answer.switchedOn) return { status: PORTAL_BRAND_STATUS.LEGACY }
  if (!answer.brand?.name) return { status: PORTAL_BRAND_STATUS.NEUTRAL }
  return { status: PORTAL_BRAND_STATUS.FIRM, brand: answer.brand }
}

const answerOf = (result) => {
  if (!result || result.error) return { failed: true }
  return { switchedOn: Boolean(result.payload?.switchedOn), brand: result.payload?.brand || null }
}

const usePortalBrand = ({ active }) => {
  const dispatch = useDispatch()
  const [answer, setAnswer] = useState(null)
  const enabled = Boolean(active)

  useEffect(() => {
    if (!enabled) return undefined
    let current = true
    Promise.resolve(dispatch(getPortalBranding()))
      .then((result) => answerOf(result), () => ({ failed: true }))
      .then((nextAnswer) => {
        if (current) setAnswer(nextAnswer)
      })
    return () => {
      current = false
    }
  }, [enabled, dispatch])

  return useMemo(() => (enabled ? portalBrandFor(answer) : null), [enabled, answer])
}

export default usePortalBrand
